import request from '../api/request';

import { handleError } from '../helpers';
import { asyncLoad } from '.';

export const getStaffList = (includeInactive = false) => dispatch =>
  asyncLoad({ url: `/stafflist?includeInactive=${includeInactive}`, params: { useMAPI: true } }, dispatch);

export const getShowInactiveUsersSetting = () => dispatch =>
  asyncLoad({ url: `/Settings/ShowInactiveUsers` }, dispatch);

export const updatePermissions = updatedPermissions => dispatch => {
  return request({
    url: '/settings',
    method: 'POST',
    body: updatedPermissions,
    apiVersion: '2.0',
  })
    .then(response => {
      if (response.status === 400) {
        throw new Error(response.data.message);
      }

      return Promise.resolve();
    })
    .catch(error =>
      handleError(`Unable to update the Permissions`, error, dispatch),
    );
};



// WEBPACK FOOTER //
// ./src/actions/staffActions.js